import { createContext, Dispatch, SetStateAction, useState } from "react";
import PatientDetailsComponent from "../../../PatientCare/Nursing/vitals/components/DetailsCard";
import RadiologyResult from "./RadiologyResult";
import RadiologyList from "./RadiologyList";
import { Button, Paper, Typography } from "@mui/material";
import { RadiologyItemType } from "../Type";
import { ArrowBack } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { EmrDataProvider } from "../../../EMR";
export type ContextType = {
  testData: RadiologyItemType | null;
  setTestData: Dispatch<SetStateAction<RadiologyItemType | null>>;
  ResultView: boolean;
  setResultView: Dispatch<SetStateAction<boolean>>;
  isCompleted: boolean;
  setIsCompleted: Dispatch<SetStateAction<boolean>>;
};
export const RadiologyContext = createContext<ContextType | null>(null);

const RadiologyMainPage = () => {
  const [testData, setTestData] = useState<RadiologyItemType | null>(null);
  const [ResultView, setResultView] = useState(false);
  const [isCompleted, setIsCompleted] = useState<boolean>(true);
  const navigateTo = useNavigate();

  const goBack = () => {
    navigateTo(-1);
  };
  return (
    <EmrDataProvider>
      <RadiologyContext.Provider
        value={{
          testData,
          setTestData,
          ResultView,
          setResultView,
          isCompleted,
          setIsCompleted,
        }}
      >
        <Paper
          sx={{ marginTop: "20px", marginX: "10px" }}
          className=" flex flex-col gap-y-3"
        >
          <div className="px-4 mt-1 flex justify-between items-center">
            <Typography
              variant="h6"
              sx={(theme) => ({ color: theme.palette.primary.main })}
            >
              Radiology Dashboard
            </Typography>
            <Button
              sx={{ marginTop: "5px" }}
              onClick={goBack}
              color="error"
              startIcon={<ArrowBack />}
            >
              back
            </Button>
          </div>
          <PatientDetailsComponent />
          {ResultView ? <RadiologyResult /> : <RadiologyList />}
        </Paper>
      </RadiologyContext.Provider>
    </EmrDataProvider>
  );
};
export default RadiologyMainPage;
